import { FC } from 'react';

import { Formik } from 'formik';
import useModal from 'ui/partials/Modal/useModal';
import { type FormikHelpers } from 'formik';
import { Pipeline } from 'utils/types';
import { useQueryClient } from '@tanstack/react-query';

import { useGetDeal, useUpdateDeal } from '../hooks';
import { DEAL_MOVE_FORM, DEAL_MOVE_SCHEMA } from '../forms/schema';
import DealMoveForm from '../forms/DealMoveForm';
import constants from '../utils/constants';

type DealMoveModalProps = {
  dealId: string;
};

const DealMoveModal: FC<DealMoveModalProps> = ({ dealId }) => {
  const { hideModal } = useModal();
  const { mutate: updateDeal, isLoading: updateLoading } = useUpdateDeal();
  const { data } = useGetDeal(dealId);
  const queryClient = useQueryClient();

  const FORM_INIT: DEAL_MOVE_FORM = {
    pipelineId: (data?.pipelineId as Pipeline)?._id,
    stageId: data?.stageId as string,
  };

  const onSubmit = (
    values: DEAL_MOVE_FORM,
    { setSubmitting, resetForm }: FormikHelpers<DEAL_MOVE_FORM>,
  ) => {
    updateDeal(
      {
        id: dealId,
        ...values,
      },
      {
        onSuccess: () => {
          hideModal();
          resetForm();
        },
        onSettled: () => {
          queryClient.invalidateQueries([constants.PIPELINES]);
          setSubmitting(false);
        },
      },
    );
  };
  return (
    <Formik<DEAL_MOVE_FORM>
      initialValues={{
        ...FORM_INIT,
      }}
      onSubmit={onSubmit}
      validationSchema={DEAL_MOVE_SCHEMA}
      enableReinitialize
    >
      {() => <DealMoveForm isLoading={updateLoading} />}
    </Formik>
  );
};

export default DealMoveModal;
